import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration from environment variables
// Fallback to hardcoded values for backward compatibility
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBKayeVHYYqsjbTKtg_0K0f41VLzIBnvdY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "madacar-yacht-charter.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "madacar-yacht-charter",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "madacar-yacht-charter.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1040480934653",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1040480934653:web:cdc622cfe29b6fd8923c94",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-83X7VYRPV2"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); 